import { lazy } from 'react';

export const misc = lazy(() => import('./misc'));
export const reports = lazy(() => import('./reports'));
